<template>
  <div class="font-jumper">
    <PageHeader
        :title="title"
        :special-back-link="true"
        :enable-back-link="true"
        @goBack="goBack"
    />
    <b-row>
      <b-col class="col-12 col-md-6 pt-4">
        <div class="inputLabel">Előnézet</div>

        <div v-if="thumbnail">
          <div class="thumbnailContainer">
            <img
                class=""
                :src="getImgFromByteArray(thumbnail)"
            />
          </div>
          <div class="thumbnailFunctions d-flex justify-content-between">
            <b-form-input v-model="fileName" :disabled="true"/>
            <div class="d-flex">
              <b-button 
                variant="secondary" 
                class="circleBtn ml-2" 
                @click="previousPage"
                :disabled="currentPage === 0"
              >
                <i class="fa fal fa-chevron-left"></i>
              </b-button>
              <b-button 
                variant="secondary" 
                class="circleBtn ml-2" 
                @click="nextPage"
              >
                <i class="fa fal fa-chevron-right"></i>
              </b-button>
              <b-button variant="secondary" class="circleBtn ml-2" @click="downloadDocument(incomeData)">
                <i class="fa fal fa-download"></i>
              </b-button>
            </div>
          </div>
        </div>

      </b-col>
      <b-col class="col-12 col-md-6 pt-4">

        <div class="inputLabel">Feltöltés időpontja</div>
        <b-form-input v-model="formattedUploadTime" :disabled="true"/>

        <div class="inputLabel">Címke</div>
        <model-select 
          v-model="selectedTag" 
          :options="listByCompany" 
          class="yellow-select uploaderSelect lightInputs" 
          @input="updateTag"
          placeholder="Címke kiválasztása"
        ></model-select>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import Api from "api-client";
import { mapGetters } from "vuex";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "DocumentDetail",
  props: {
    title: {
      type: String,
      default: "Pénzforgalom"
    },
    resourceType: {
      type: String,
      default: "CASH_FLOW"
    }
  },
  components: {
    PageHeader,
    ModelSelect
  },
  data() {
    return {
      incomeData: {},
      loading: false,
      listByCompany: [],
      selectedTag: null,
      fileName: "",
      thumbnail: undefined,
      currentPage: 0,
      totalPages: 1,
    };
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },

    updateTag() {
      if (!this.incomeData.id) return;

      const tagsToSave = [];
      if (this.selectedTag && this.selectedTag !== -1) tagsToSave.push(this.selectedTag);

      Api.modifyResourceTags(this.incomeData.id, tagsToSave)
        .then(() => {
          this.$toast.success({
            title: this.$t("toast.modify-success"),
            message: "A címke sikeresen módosítva",
          });
          this.getIncomeData(false);
        })
        .catch(() => {
          this.$toast.error({
            title: this.$t("toast.modify-failed"),
            message: "A címke módosítása nem sikerült",
          });
        });
    },

    getListByCompany() {
      let self = this;
      Api.getAvailableTags(self.getActiveCompany.id, self.resourceType).then((resp) => {
        self.listByCompany = [];

        resp.data.forEach((data) => {
          if (!data.isDateRelated) {
            self.listByCompany.push({
              value: data.id,
                text: data.name,
              });
          }
        });

        self.listByCompany.unshift({
          value: -1,
          text: "Nincs címke",
        });
      });
    },

    downloadDocument(data) {
      let self = this;
      self.loading = true;
      Api.fileDownloadNEW(data.fileStoreId)
        .then((resp) => {
          console.log("fileDownload", resp.data);
          self.forceFileDownload(resp, data);
          self.loading = false;
        })
        .catch(() => {
          self.loading = false;
          self.$toast.error({
            title: "Hiba történt",
            message: "A fájl letöltése nem sikerült"
          });
        });
    },

    forceFileDownload(response, item) {
      let self = this;
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      if (item) {
        if (response.headers["content-type"] === "application/zip") {
          link.setAttribute("download", item.name + ".zip");
        } else {
          link.setAttribute("download", item.name);
        }
      } else {
        if (response.headers["content-type"] === "application/zip") {
          link.setAttribute("download", self.getStrMilliseconds() + ".zip");
        } else {
          link.setAttribute("download", self.getStrMilliseconds());
        }
      }
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }, 100);
    },

    getStrMilliseconds() {
      let d = new Date();
      return d.getTime().toString();
    },

    getIncomeData(loadThumbnail = true) {
      let self = this;
      Api.getFileDetails(this.$route.params.id)
        .then((resp) => {
          console.log("getIncomeData", resp.data);
          self.incomeData = resp.data;
          self.fileName = self.incomeData.name.split('.')[0];

          this.getListByCompany();

          let tags = this.getTagsFromFileDetails(this.incomeData);
          let nonDateTags = this.getNonDateTagsAsObject(tags);

          if(nonDateTags.length !== 0) {
            this.selectedTag = nonDateTags[0].id;
          } else {
            this.selectedTag = -1;
          }
        })
        .catch(() => {
          self.loading = false;
        });

      if (loadThumbnail) {
        this.loadThumbnail(0);
      }
    },

    getImgFromByteArray(encoded) {
      return "data:image/png;base64," + encoded;
    },

    getNonDateTagsAsObject(tagList) {
      return tagList.filter((t) => !this.isDateTag(t));
    },

    getTagsFromFileDetails(fileDetails) {
      if (Array.isArray(fileDetails.tags)) {
        return fileDetails.tags;
      }

      return [fileDetails.commonTag, fileDetails.dateTag].filter(Boolean);
    },

    isDateTag(tag) {
      return Boolean(tag.type && tag.type.match(/DATE_PERIOD_YEAR|DATE_PERIOD_QUARTER|DATE_PERIOD_MONTH/g));
    },

    loadThumbnail(page = 0) {
      const params = {
        id: this.$route.params.id,
        companyId: this.getActiveCompany.id,
      };

      Api.getResourceThumbnail(params.id, page, false)
        .then((resp) => {
          this.thumbnail = resp.data.content;
          this.currentPage = page;
          // Note: Backend might return total pages info in the future
          // For now, we'll disable next button when there's no more content
        })
        .catch((err) => {
          console.error(err);
          // If error on non-zero page, it means we've reached the end
          if (page > 0) {
            this.totalPages = page;
            this.currentPage = page - 1;
            // Load previous page
            this.loadThumbnail(page - 1);
          }
        });
    },

    nextPage() {
      this.loadThumbnail(this.currentPage + 1);
    },

    previousPage() {
      if (this.currentPage > 0) {
        this.loadThumbnail(this.currentPage - 1);
      }
    },
  },
  mounted() {
    this.getIncomeData();
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
    formattedUploadTime() {
      if (!this.incomeData.createdOn) return '';
      const date = new Date(this.incomeData.createdOn);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>
.inputLabel {
  margin-left: 16px;
  margin-bottom: 8px;
}

.thumbnailContainer {
  width: 100%;
  height: 705px;
  overflow: hidden;
  border-radius: 32px;
  box-shadow: 0px 20px 30px 0px #0000001A;
  background-color: white;
}

.thumbnailContainer img {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

.thumbnailFunctions {
  position: absolute;
  width: 90%;
  margin-top: -75px !important;
  margin-left: 10px;
  padding: 10px;
  background-color: white;
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  box-shadow: 0px 20px 30px 0px #0000001A;
}

.thumbnailFunctions input {
  margin-bottom: 0px !important;
}

.circleBtn {
  width: 40px !important;
  height: 40px !important;
  text-align: center !important;
  font-size: 14px !important;
  padding: 0px !important;
  border: 1px solid #AEBFC7 !important;
}
</style>
